<template>
  <ul class="c-games_list c-games_list-wrap js-app-ul">
    <li
      v-for="(app, index) in apps"
      :key="'app_item_' +  app.application.id"
      :id="`app_item_list_${index}`"
      :class="['js-app-li']"
      v-if="app.application.id != 5687110740738048"
    >
      <game-entity :app="app" :ua="ua" />
    </li>
    <li
      v-if="ua === 'sp'"
      :key="`empty_${n}`"
      class="is-empty"
      v-for="n in 12"
    ></li>
  </ul>
</template>

<script>
import GameEntity from '../molecules/GameEntity.vue'

export default {
  components: {
    GameEntity
  },
  props: {
    apps: Array,
    ua: String
  },
  mounted () {
    this.$nextTick(() => { this.triggerCustomHTMLEvent() })
  },
  updated () {
    this.$nextTick(() => { this.triggerCustomHTMLEvent() })
  },
  methods: {
    triggerCustomHTMLEvent () {
      if (document.createEvent) {
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent('gamelist_updated', true, true)
        return window.dispatchEvent(evt)
      }
    }
  }
}
</script>
